





































































import { Component, Mixins, Watch, Vue } from 'vue-property-decorator'
import AbpBase from '@/lib/abpbase'
import CustomForm from '@/components/custom-form/index.vue'
import EmployeeApi from '@/api/employee/index'
import appconst from '@/lib/appconst'
import VipApi from '@/api/vip/list'
import ShopApi from '@/api/shopInfo/index'

@Component({
  components: {
    CustomForm,
  },
})
export default class EmployeeList extends AbpBase {
  templateUrl = `${appconst.remoteServiceBaseUrl}/api/Vip/Employee/TemplateFile`
  uploadUrl = `${appconst.remoteServiceBaseUrl}/api/Vip/Employee/excel/upload`

  filters = [
    {
      label: '关键字搜索：',
      type: 'input',
      props: {
        placeholder: '',
      },
      key: 'Filter',
    },
    // {
    //   label: '是否在职',
    //   type: 'select',
    //   key: 'IsActive',
    //   props: {
    //     clearable: true,
    //     placeholder: '请选择',
    //   },
    //   options: [
    //     {
    //       value: 1,
    //       text: '在职',
    //     },
    //     {
    //       value: 0,
    //       text: '已离职',
    //     },
    //   ],
    // },
    {
      label: '所属门店',
      type: 'select',
      key: 'storeId',
      defaultValue: [],
      props: {
        // 'max-tag-count': 2,
        // multiple: true,
        placeholder: '请选择',
      },
      options: [],
    },
  ]
  columns: any[] = [
    {
      title: '头像',
      slot: 'headImgUri',
      align: 'center',
      // width: 80,
    },
    {
      title: '姓名',
      key: 'nickName',
      align: 'center',
    },
    {
      title: '性别',
      key: 'gender',
      align: 'center',
    },
    {
      title: '工号',
      key: 'vipCode',
      align: 'center',
      // width: 80,
    },
    // {
    //   title: '身份证号',
    //   key: 'identityNumber',
    //   align: 'center',
    // },
    {
      title: '手机号',
      key: 'phoneNumber',
      align: 'center',
    },
    // {
    //   title: '会员人数',
    //   key: 'vipCount',
    //   align: 'center',
    // },
    {
      title: '所属门店',
      key: 'storeName',
      align: 'center',
    },
    // {
    //   title: '职位',
    //   key: 'position',
    //   align: 'center',
    //   width: 100,
    // },
    // {
    //   title: '累计业绩',
    //   key: 'totalAmount',
    //   align: 'center',
    // },
    // {
    //   title: '累计收益',
    //   key: 'totalEarnings',
    //   align: 'center',
    // },
    // {
    //   title: '状态',
    //   slot: 'isActive',
    //   align: 'center',
    // },
    // {
    //   title: '绑定状态',
    //   slot: 'isBind',
    //   align: 'center',
    // },
    // {
    //   title: '离职日期',
    //   slot: 'dateOfDeparture',
    //   align: 'center',
    // },
    {
      title: '出生日期',
      slot: 'birthDay',
      align: 'center',
    },
    {
      title: '操作',
      slot: 'action',
      type: 'action',
      align: 'center',
    },
  ]
  isCheckAll: boolean = false
  loading: boolean = false
  tableData: any[] = []
  currentPage = 1
  pageSize = 10
  totalCount = 0
  showTag = false
  tagList = []
  submitChange(form, valid) {
    if (valid) {
      this.getTableData(form)
    }
  }

  mounted() {
    this.submitFn()
    this.getStoreList()
  }

  submitFn() {
    let form: any = this.$refs.lineForm
    form.submit()
  }

  /**
   * 获取导购列表
   */
  getTableData(form = {}) {
    this.isCheckAll = false
    let Filter = form['Filter']
    let storeId = form['storeId']
    let { pageSize, currentPage } = this
    this.loading = true
    VipApi.getNewVipList(pageSize, currentPage, Filter, storeId)
      .then((res) => {
        this.loading = false
        let { totalCount, items } = res.data
        this.totalCount = totalCount
        this.tableData = items
        console.log(this.tableData)
      })
      .catch(() => {
        this.loading = false
        this.totalCount = 0
        this.tableData = []
      })
  }

  /**
   * 编辑导购信息
   */
  editEmployeeFn(id?) {
    this.$router.push({
      name: 'editEmployee',
      query: {
        id: id,
      },
    })
  }
  // 同步人员
  syncPerson() {
    VipApi.syncAllEmployee().then(res => {
      this.loading = false
      this.$Notice.success({
        title: '同步成功'
      })
      this.submitFn()
    }).catch(err => {
      this.loading = false
    })
  }

  /**
   * 设置导购是否离职
   */
  leaveOffice(id) {
    let date = null
    this.$Modal.confirm({
      render: (h) => {
        return h('DatePicker', {
          props: {
            autofocus: true,
            placeholder: '请输入离职日期.',
          },
          style: {
            width: '300px',
          },
          on: {
            input: (val) => {
              date = this.dateString(val)
            },
          },
        })
      },
      onOk: () => {
        this.loading = true
        EmployeeApi.leaveOffice(id, date)
          .then((res) => {
            this.loading = false
            this.submitFn()
          })
          .catch(() => {
            this.loading = false
          })
      },
    })
  }

  /**
   * 删除导购
   */
  deleteEmployee(id) {
    this.$Modal.confirm({
      title: '提示',
      content: `删除无法恢复, 是否继续?`,
      onOk: () => {
        this.loading = true
        EmployeeApi.deleteVipInfos(id)
          .then((res) => {
            this.loading = false
            this.submitFn()
          })
          .catch((err) => {
            this.loading = false
          })
      },
    })
  }

  /**
   * 导购详情
   */
  goDetailFn(id) {
    this.$router.push({
      name: 'employeeDetail',
      query: {
        id: id,
      },
    })
  }

  // 获取门店列表
  getStoreList() {
    ShopApi.getList2(999, 0, '').then((res) => {
      console.log('门店列表', res)
      let obj = this.filters.find(item => item.label == '所属门店')
      if (obj) {
        obj.options = res.data.items.map(item1 => {
          return {
            value: item1.id,
            text: item1.displayName
          }
        })
      }
    })
  }

  handleTableAllCancel() {
    this.isCheckAll = false
  }

  handleTableAll() {
    this.isCheckAll = true
  }

  handleSelectChange(selection) {
    this.isCheckAll = selection.length === this.tableData.length
  }

  handleSelectAll() {
    if (!this.tableData.length) return
      ; (this.$refs.selection as any).selectAll(!this.isCheckAll)
  }

  pageChange(currentPage) {
    this.currentPage = currentPage
    this.submitFn()
  }
  pageSizeChange(pageSize) {
    this.pageSize = pageSize
    this.currentPage = 1
    this.submitFn()
  }

  uploadSuccess() {
    this.$Message.success('上传文件成功，导入比较耗时，请稍后刷新查看结果')
    this.pageChange(1)
  }
  downloadTemplate() {
    location.href = this.templateUrl
  }

  refresh() {
    this.pageChange(1)
  }
}
